import { render, staticRenderFns } from "./ComponentResolverPublic.vue?vue&type=template&id=20c6857b"
import script from "./ComponentResolverPublic.js?vue&type=script&lang=js&external"
export * from "./ComponentResolverPublic.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports